<template>
    <div>
        <div class='lt-xl absolute-center text-center q-title'>
            <p>Извините!</p> Для эффективной работы отчета нужно более выское разрешение экрана.
        </div>
        <div class='gt-lg'>
            <q-card inline style="width: 60%">
                <q-card-title>
                    Выбор периода                            
                    <div slot="right" class="row items-center">
                        <downloadexcel
                            :data   = "getExcelData"
                            :fields = 'getExcelFields'
                            :name='getExcelFileName()'
                            :meta = "[
                                {
                                    'key': 'charset',
                                    'value': 'utf-8'
                                },
                                {
                                    'key': 'lang',
                                    'value': 'ru'
                                }

                            ]"
                        >
                            <q-btn color='primary' icon="fas fa-file-excel" label="Экспорт в excel" ></q-btn>
                        </downloadexcel>

                        
                        <!-- <q-icon name="fas fa-file-excel" color='primary' style='cursor:pointer'/> -->


                    </div>
                </q-card-title>
                <q-card-separator />
                <q-card-main>
                    <div class='row full-width items-baseline'>
                        <q-datetime v-model="dateFrom" type="date"  clearable placeholder='Начало периода' inverted class='q-ma-xs' format="D MMMM YYYY"/>
                        <q-icon name ="fas fa-arrow-right" class='q-ml-md q-mr-md' color='grey-7'/>
                        <q-datetime v-model="dateTo" type="date"  clearable placeholder='Конец периода' inverted  class='q-ma-xs'  format="D MMMM YYYY"/>
                    </div>
                </q-card-main>

                <q-card-separator />
                <q-card-actions >
                    <div class="row no-wrap justify-between full-width">
                        <div class='row no-wrap'>
                            <q-icon flat round dense icon="event" />
                            <q-btn flat color='primary' label="Прошлый месяц" icon="event" @click="setPrevMonth"/>
                            <q-btn flat color= 'secondary' label="Этот месяц" icon="event" @click="setThisMonth"/>
                            <q-btn invert color= 'positive' label="Загрузить" outline icon="fas fa-play" @click='getMainReport' />
                        </div>
                        <q-btn  class='q-ml-lg' color='negative' outline icon="fas fa-filter"  label='Очистить фильтры' @click='clearFilters'/>
                    </div>
                </q-card-actions>
            </q-card>         

            <q-card class='q-mt-md ellipsis-2-lines'>


                    <!-- заголовок таблицы -->
                    <div class='bg-primary row no-wrap q-pa-sm text-white q-caption items-center text-center shadow-2'>
                        <div style='width:3%' class=''>
                                <q-select
                                    v-model="payFilter"
                                    :options="getPayStatusList"
                                    v-bind:class="getPayStatusColor"
                                    inverted-light                                
                                    class='ellipsis'
                                />  

                        </div>                        
                        <div style='width:4%;' class='text-white text-center' >
                            №
                        </div>
                        <div style='width:6.5%;' class='ellipsis'>
                            Дата
                        </div>
                        <div style='width:11%; ' class='q-ma-xs'>
                            <q-select
                                v-model="contragentFilter"
                                :options="contragentList"
                                color='white'
                                inverted-light                                
                                class='text-primary'
                                float-label="Заказчик"
                            />   
                        </div>
                        <div style='width:12%' class='q-ma-xs'>
                            <q-select
                                v-model="directionFilter"
                                :options="directionList"
                                color='white'
                                inverted-light                                
                                class='text-primary'
                                float-label="Направление"
                            />
                        </div>
                        <div style='width:13%' class='q-ma-xs'>
                            <q-select
                                v-model="materialFilter"
                                :options="materialList"
                                color='white'
                                inverted-light                                
                                class='text-primary'
                                float-label="Материал"
                            />   
                        </div>
                        <div style='width:8%' class='q-ma-xs ellipsis'>
                            Размер
                        </div>
                        <div style='width:5%' class='q-ma-xs ellipsis'>
                            Кол-во
                        </div>
                        <div style='width:5%' class='q-ma-xs ellipsis'>
                            Цена(м<sup>2</sup>)
                        </div>
                        <div style='width:5%' class='q-ma-xs ellipsis'>
                            Ст.печати
                        </div>
                        <div style='width:5%' class='q-ma-xs ellipsis'>
                           Обработка
                        </div>
                        <div style='width:5%' class='q-ma-xs ellipsis'>
                           Ст.обработки
                        </div>
                        <div style='width:5%' class='q-ma-xs ellipsis'>
                           Доп.работы
                        </div>
                        <div style='width:5%' class='q-ma-xs ellipsis'>
                           Итого
                        </div>
                        <div style='width:8%' class='q-ma-xs ellipsis'>
                            <q-select
                                v-model="managerFilter"
                                :options="managerList"
                                color='white'
                                inverted-light                                
                                class='text-primary'
                                float-label="Менеджер"
                            />   
                        </div>
                    </div>

<!-- конец заголовка. НАЧАЛО ОСНОВНЫХ ДАННЫХ -->

                    <div v-for="(order, key) in getOrders" :key=key class='myLine'>

                        <div class='myLine row no-wrap items-center q-pt-sm q-pb-sm text-center q-caption'>
                            <div style='width:3%'>
                                <i class="fas fa-circle" v-bind:class='payStatus(order)'>
                                        <q-tooltip :delay="500">
                                            {{payStatusText(order)}}
                                        </q-tooltip>  
                                </i>
                            </div>
                            <div style='width:4%' class="text-primary">
                                {{order.main_id}}
                            </div>
                            <div style='width:6%;' class='text-center'>
                                <div class='text-primary'>{{getNiceDate(order.created_at).date}}</div>
                                <div class='text-grey-7'>{{getNiceDate(order.created_at).time}}</div>
                            </div>
                            <div style='width:10%;' class='text-center text-faded ellipsis-2-lines q-ma-xs'>
                                {{getContragent(order)}}
                            </div>
                            <div style='width:11.1%;' class='text-center text-faded ellipsis-2-lines q-ma-xs'>
                                {{getDirection(order)}}
                            </div>
                            <div style='width:12%;' class='text-center text-faded ellipsis-2-lines q-ma-xs'>
                                {{getMaterial(order)}}
                            </div>
                            <div style='width:8%;' class='q-ml-xs text-faded'>
                                <div>{{getSize(order).size}}</div>
                                <div>{{getSize(order).square}} m<sup>2</sup></div>
                            </div>
                            <div style='width:5%;' class='text-faded' >
                                {{getNumber(order)}}
                            </div>
                            <div style='width:5%;'  class='q-ml-xs text-faded' >
                               {{getPriceForMeter(order)}}
                            </div>
                            <div style='width:5%;' class='text-faded' >
                              {{getPrintItog(order)}}
                            </div>                            
                            <div style='width:5%;' class='text-faded'>
                                {{getPost(order).types}}
                            </div>                            
                            <div style='width:5%;' class='q-pl-xs text-faded'>
                                {{getPostCost(order)}}
                            </div>   
                            <div style='width:5%;'  class='q-pl-xs text-faded'>
                                {{getExtWorkCost(order)}}
                            </div>           
                            <div style='width:5%;'  class='q-pl-sm text-primary'>
                                {{order.cost != null ? order.cost : 0}}
                            </div>           
                            <div style='width:8%;' class='text-faded'>
                                {{getManagerName(order).surname}}
                            </div>  
                        </div>
                        <q-card-separator/>
                    </div>

                <!-- ИТОГ -->
                    <div  class='bg-grey-4 text-bold text-black text-center row no-wrap q-caption q-pt-md q-pb-md items-baseline'>
                        <div style='width:48%'></div>
                        <div style='width:8%'>{{itogSquare}} м<sup>2</sup></div>
                        <div style='width:10%'></div>
                        <div style='width:5%'>{{itogPrintCost}}</div>
                        <div style='width:5%'></div>
                        <div style='width:5%' class='q-pl-xs'>{{itogPostCost}}</div>                        
                        <div style='width:5%' class='q-pl-xs'>{{itogExtWorkCost}}</div>                        
                        <div style='width:5%' class='q-pl-sm'>{{itog}}</div>                        
                    </div>
            </q-card>
        </div>
    </div>
</template>

<script>
/* eslint-disable */

import downloadexcel from 'vue-json-excel';

export default {
    
    name : 'mainReport',

    components : {
        downloadexcel,
    },

    data() {
        return {
            dateFrom : null,
            dateTo : null,
            itogSquare : 0,
            itogPrintCost : 0,
            itogPostCost : 0,
            itog : 0,
            itogExtWorkCost : 0,

            managerFilter : -1,
            directionFilter : -1,
            contragentFilter : -1,
            materialFilter : -1, 
            payFilter : -1,
        }
    },
    created() {
        if (this.$store.getters.getAllDirections.length == 0) this.$store.dispatch('getDirections');
        if (this.$store.getters.allContragents.length == 0) this.$store.dispatch('retrieveContragents');
        if (this.$store.getters.getAllMaterials.length == 0) this.$store.dispatch('getMaterials');
        if (this.$store.getters.getAllPostTypes.length == 0) this.$store.dispatch('getPostTypes');
         if (this.$store.getters.allUsers.length == 0) this.$store.dispatch('retrieveUsers');
    },

    computed : {
        getExcelData() {
            let orders = this.getOrders; // получаем массив данных
            let result = [];

            orders.forEach(element => { // начинаем готовить данные
                let opt = element.options;
                let main_id = element.main_id;

                let d = new Date(element.created_at);
                let created_at = d.toLocaleDateString();

                let q = this.$store.getters.getContragentById(element.contragent);
                let contragent = q != null ? q.name : 'Не задан';

                q = this.$store.getters.getDirectionById(opt.stanok);
                let direction = q != null ? q.name : 'Не задан';
                
                q = this.$store.getters.getMaterialById(opt.material);
                let material = q != null ? q.name : 'Не задан';

                let size = '-';
                if ((opt.width != null) && (opt.height != null)) size = opt.width + 'x' + opt.height;

                let printSquare = ((opt.height != null) && (opt.width != null)) ? Math.round(opt.height * opt.width *100)/100 : 0;
                let printPerimetr =((opt.height != null) && (opt.width != null)) ? Math.round((+opt.height + +opt.width)*2*100)/100 : 0;
                printSquare = (printSquare + '').replace('.',',');
                printPerimetr = (printPerimetr + '').replace('.',',');


                let number = opt.number != null ? opt.number : '-';
                let printPrice = opt.printForMeterCost != null ? (opt.printForMeterCost+'').replace('.',',') : '-';
                let printCost = opt.printCost != null ? (opt.printCost+'').replace('.',',') : '0';
                let postTypes = this.getPost(element).types;
                let postCost = opt.postCost != null ? (opt.postCost+'').replace('.',',') : '0';
                let extWorkCost = this.getExtWorkCost(element);
                let extWorkDescription = this.getExtWorkDescription(element);
                let itog = (element.cost+'').replace('.',',');
                
                let payStatus = 'Нет счета';
                if (element.bill_out != null) payStatus = 'Выставлен счет. Нет оплаты';
                if (element.pay_status ==1) payStatus = 'Частичная оплата';
                if (element.pay_status ==2) payStatus = 'Оплачен';

                result.push({
                    'main_id' : main_id,
                    'created_at' : created_at,
                    'contragent' : contragent,
                    'direction' : direction,
                    'material' : material,
                    'size' : size,
                    'number' : number,
                    'printPrice' : printPrice,
                    'printSquare' : printSquare,
                    'printPerimetr' : printPerimetr,
                    'printCost' : printCost,
                    'postTypes' : postTypes,
                    'postCost' : postCost,
                    'extWorkCost' : extWorkCost,
                    'extWorkDescription' : extWorkDescription,
                    'itog' : itog,
                    'payStatus' : payStatus,
                    'mainComment' : element.comment,
                    'fileComment' : opt.comment
                });
            });
            return result;
        },

        getExcelFields() { // возвращает заголовки столбцов таблицы

            return {
                '№ заказа' : 'main_id',
                'Дата' : 'created_at',
                'Заказчик' : 'contragent',
                'Вид работ' :'direction',
                'Материал' : 'material',
                'Размер' : 'size',
                'Количество' : 'number',
                'Цена за кв.м.' : 'printPrice',
                'Площадь' : 'printSquare',
                'Периметр' : 'printPerimetr',
                'Стоимость печати' : 'printCost',
                'Обработка' : 'postTypes',
                'Стоимость обработки' : 'postCost',
                'Доп.работы' : 'extWorkCost',
                'Описание доп.работ' : 'extWorkDescription',
                'Итого' : 'itog',
                'Статус оплаты' : 'payStatus',
                'Комментарии к заказу' : 'mainComment',
                'Комментарии к файлу' : 'fileComment'
            }

        },

        getPayStatusList() {
            return  [
                        {
                                label : '',
                                sublabel: '----------',
                                value: -1,
                        },


                        {
                                icon: 'fas fa-circle',
                                leftColor: 'negative',
                                label : '',
                                sublabel: 'Без оплаты',
                                value: 0,
                        },

                        {
                                icon: 'fas fa-circle',
                                leftColor: 'primary',
                                label : '',
                                value: 1,
                                sublabel: 'Частичная'
                        },
                        {
                                icon: 'fas fa-circle',
                                leftColor: 'positive',
                                label : '',
                                value: 2,
                                sublabel: 'Оплачено'
                        },
                    ];
        },

        getPayStatusColor() {
            if (this.payFilter == -1) return 'bg-white'; // нет фильтра
            if (this.payFilter < 1) return 'bg-red';
            if (this.payFilter < 2) return 'bg-blue-4';
            return 'bg-positive';
        },

        getOrders() {

            let orders = this.$store.getters.getMainReportOrders;
            
            let result = orders.filter(item => {
                let answer = true;
                answer = this.contragentFilter > -1 ? answer && (item.contragent == this.contragentFilter) : answer;
                answer = this.managerFilter > -1 ? answer && (item.manager == this.managerFilter) : answer;
                let opt = item.options;
                
                if (opt.stanok != null) {
                   answer = this.directionFilter > -1 ? answer && (opt.stanok == this.directionFilter) : answer;
                }
                if (opt.material != null) {
                   answer = this.materialFilter > -1 ? answer && (opt.material == this.materialFilter) : answer;
                }
                if (this.payFilter > -1) {
                    answer = answer && (item.pay_status == this.payFilter);
                }
                return answer;
            });
            this.itogSquare = 0;
            this.itogPrintCost = 0;
            this.itogPostCost = 0;
            this.itog = 0;
            this.itogExtWorkCost = 0;
            //считаем итоги
            result.forEach(element => {
                this.itogSquare += this.getSize(element).square;
                this.itogPrintCost += this.getPrintItog(element);
                this.itogPostCost += this.getPostCost(element);
                this.itogExtWorkCost += this.getExtWorkCost(element);
                let i = element.cost != null ? element.cost : 0
                this.itog += i*1;
            });
            // округляем
            this.itogSquare = Math.round(this.itogSquare*100)/100;
            return result;

        },
        
        contragentList() {
            let u = this.$store.getters.allContragents;
            let result = [{label:'------', value : -1}];
            u.forEach(element => {
                result.push({
                    label : element.name,
                    value : element.id,
                })
            });
            return result;
        },

        materialList() {
           let u = this.$store.getters.getAllMaterials;
            let result = [{label:'------', value : -1}];
            u.forEach(element => {
                result.push({
                    label : element.name,
                    value : element.id,
                })
            });
            return result; 
        },

        managerList() {
            // делаем список менеджеров, которые есть в заказах
            let orders = this.$store.getters.getMainReportOrders;
            let result = [{label:'------', value : -1}];
            orders.forEach(element => {
                let q = result.findIndex(item => {
                    return element.manager == item.value;
                })
                if (q == -1) { // значит такого еще нет
                    let user = this.$store.getters.getUserById(element.manager);
                    result.push({
                        label : user.surname,
                        value : user.id,
                    })
                }
            });
            return result;
        },

        directionList() {
            let d = this.$store.getters.getAllDirections;
            let result = [{label:'------', value : -1}];
            d.forEach(element => {
                result.push({
                    label : element.name,
                    value : element.id,
                })
            });
            return result;
        }
    },
    methods : {
        exportXlS () {
            this.$refs.excelComponent.generate();
        },

        payStatusText(order) {
            if ((order.pay_info == null)||(order.pay_status == 0)) return 'Не оплачен';
            else {
                let q = JSON.parse(order.pay_info);
                let result = '';
                for (var i in q) {
                    result += i + ': '+q[i]+'  ';
                }
                return result;
            }
        },

        payStatus(order) {
            return {
                'text-red': order.pay_status == 0,
                'text-primary' : order.pay_status == 1,
                'text-green' : order.pay_status == 2,
            }
        },

        clearFilters() {
            this.contragentFilter = -1;
            this.directionFilter = - 1;
            this.managerFilter = -1;
            this.materialFilter = -1;
            this.payFilter = -1;
        },

        getManagerName(order) {
            let q = this.$store.getters.getUserById(order.manager);
            return q != null ? q : 'не задан';
        },

        getExtWorkDescription(order) {
            let opt = order.options;
            let ext = opt.extWork != null ? opt.extWork : [];
            let result = '';

            ext.forEach(element => {
                if (element.eachNumber) result +='За каждый: ';
                result += element.name + " : " + element.cost +';';
            });
            return result;

        },

        getExtWorkCost(order) { // возвращает стоимость дополнительных работ
            
            let opt = order.options;
            let ext = opt.extWork != null ? opt.extWork : [];
            let result = 0;
            ext.forEach(element => {
                result += element.eachNumber ? element.cost*opt.number : element.cost;
            });

            result = Math.round(result*100)/100;

            return result;
        },

        getPostCost(order) {
             let opt = order.options;
             return opt.postCost != null ? opt.postCost : 0;   

        },

        getPost(order) {
             let opt = order.options;
             let p = opt.post != null ? opt.post : {"top":[],"right":[],"bottom":[],"left":[],"space":[]};
             let postResult = [];
             for (let key in p) {
                let value = p[key]; // получаем сторону обработки
                value.forEach(element => { //циклим по всем элементам обработки в стороне и проверяем есть ли такая в итоговой выборке
                    if (!postResult.includes(element)) postResult.push(element);
                });
             }
             // на этом этапе сформирована выборка. Теперь нужно сформировать условные обозначения
            let resultSt = '';
            postResult.forEach(element => {
                let s = this.$store.getters.getPostTypeById(element);
                if (s != null) {
                    if (resultSt != '') resultSt +='-';
                    resultSt += s.shortName;
                }
            });
            let r = postResult.length == 0 ? 'нет' : 'есть';
            return {isPost : r, types : resultSt > '' ? resultSt : '-'}
        },

        getPrintItog(order) {
             let opt = order.options;
             return opt.printCost != null ? opt.printCost : 0;   
        },
        getPriceForMeter(order) {
            // printForMeterCost
             let opt = order.options;
             return opt.printForMeterCost != null ? opt.printForMeterCost : 0;
        },

        getNumber(order) {
            let opt = order.options;
            return opt.number != null ? opt.number : 0;
        },

        getSize(order) {
            let opt = order.options;
            let x = opt.width != null ? opt.width : '';
            let y = opt.height != null ? opt.height : '';
            let s = Math.round(x*y*100)/100;
            return {size:x+'x'+y, square : s};
        },

        getMaterial(order) {
            let opt = order.options;
            return opt.material != null ?  this.$store.getters.getMaterialById(opt.material) != null ? this.$store.getters.getMaterialById(opt.material).name : 'не задан' : 'не задан';
        },

        getContragent(order) {
            return this.$store.getters.getContragentById(order.contragent) != null ? this.$store.getters.getContragentById(order.contragent).name : 'не задан';
        },

        getDirection(order) {
            let opt = order.options;
            return opt.stanok != null ?  this.$store.getters.getDirectionById(opt.stanok) != null ? this.$store.getters.getDirectionById(opt.stanok).name : 'не задан' : 'не задан';
        },

        getNiceDate(d) {
            let myD = new Date(d);
            let offset = myD.getTimezoneOffset() / 60;
            myD.setHours(myD.getHours()-offset);
            return {date : myD.toLocaleDateString(), time : myD.toLocaleTimeString()};
        },
                
        getMainReport() {
            if ((this.dateFrom == null) || (this.dateTo == null)) {
                this.$admns.showNotify('Задайте период отчета','error','Проверка данных');
            } else {
                // если что меняем местами даты
                let d1 = new Date(this.dateFrom);
                let d2 = new Date(this.dateTo);

                if (d1>d2) { // значит неправильное расположение дат - меняем местами
                    let q = this.dateFrom;
                    this.dateFrom = this.dateTo;
                    this.dateTo = q;
                }
                //надо скорректировать время: в ОТ поставить 0 часов, в ТУ поставить 23-59
                d1 = new Date(this.dateFrom); // опять получаем даты
                d2 = new Date(this.dateTo);
                d1.setHours(0, 0, 0);
                d2.setHours(23,59,59);
                
                // d2.setHours(23, 59, 59);

                this.$store.dispatch('getMainReport', {fromDate : d1, toDate : d2})
                .then()
                .catch(error=> {
                    this.$admn.showNotify('Ошибка при получении данных','error','Ошибка сервера');
                });
            }
        },

        setThisMonth() {
            let firstDate = new Date();
            firstDate.setDate(1);

            let lastDate = new Date();
            lastDate.setMonth(lastDate.getMonth()+1);
            lastDate.setDate(0);
            
            this.dateFrom = firstDate;
            this.dateTo = lastDate;

            this.getMainReport(); // сразу грузим данные
        },

        setPrevMonth() {
            let firstDate = new Date();
            let q = firstDate.getMonth()-1;
            firstDate.setMonth(q, 1);

            let lastDate = new Date();
            lastDate.setDate(0);

            this.dateFrom = firstDate.toDateString();
            this.dateTo = lastDate.toDateString();
            
            this.getMainReport(); // сразу грузим данные
        },

        getExcelFileName() {
            let d = new Date();
            return 'Отчет за ' + d.toLocaleDateString()+'.xls';
        }

    }

}
</script>
<style lang="scss" scoped>
    .myLine {
        // background-color : red !important;
        cursor : pointer;
        &:hover {
            background-color : rgb(180, 255, 180) !important;
        }
    }
</style>
